// 网点管理-服务商
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :processId="processId" :_dataId.sync="dataId" :parent-target="_self"
                  @reload="$reloadHandle" @goBackIndex="goBackIndex" :showSave="showSave"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">
        <div class="grid-height" style="height: calc(100vh - -35px);">
          <vxe-grid ref="table-m1" :stripe="true" border="default" :row-config="{ isHover: true }" height="100%" v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
                    @custom="$vxeTableUtil.customHandle">

            <template #xxx="{row}">
              <span></span>
            </template>

            <template #form>
              <div class="clearfix screen-btns">
                <div class="fl">
                  <vxe-button status="primary" class="button-sty" icon="el-icon-plus" @click="openEditDialog(0, 'edit')" v-if="snUserChangeAdd||mySnUserChangeAdd">新增
                  </vxe-button>
                </div>
                <div class="fr">
<!--                  <vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text" status="primary"-->
<!--                              plain>重置-->
<!--                  </vxe-button>-->
                  <vxe-button status="warning" icon="el-icon-search" class="button-sty" @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData"
              @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
<!--                <vxe-form-item title="变更单号:" field="name">
                  <template v-slot>
                    <el-input v-model="formData.userAccount" size="small" clearable/>
                  </template>
                </vxe-form-item>-->
                <vxe-form-item title="服务商名称:" field="manPhonee">
                  <template v-slot>
                    <el-input v-model="formData.userName" size="small" clearable/>
                  </template>
                </vxe-form-item>

                <vxe-form-item title="变更状态:" field="status">
                  <template v-slot>
                    <el-select v-model="formData.stat" clearable>
                      <el-option label="全部" :value="null"></el-option>
                      <el-option :value="1" label="制单"></el-option>
                      <el-option :value="2" label="审核中"></el-option>
                      <el-option :value="5" label="已审核"></el-option>
                      <el-option :value="6" label="驳回"></el-option>
                      <el-option :value="99" label="取消"></el-option>
                      <!-- <el-option :value="91" label="暂停"></el-option>
                      <el-option :value="92" label="暂挂"></el-option>
                      <el-option :value="98" label="撤消"></el-option>
                      <el-option :value="99" label="黑名单"></el-option> -->
                    </el-select>
                  </template>
                </vxe-form-item>
              </vxe-form>
            </template>
            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
              <!--              <pager :totalResult="page2.totalResult"></pager>-->
            </template>
            <template #option="{row}">
              <div>
                <!-- <a href="javascript:void(0);" class="a-link" @click="openEditDialog(row.id)">
                  <el-tooltip effect="dark" content="查看" placement="top"
                              popper-class="tooltip-skin">
                    <i class="el-icon-edit"/>
                  </el-tooltip>
                </a> -->

                <el-dropdown @command="handleCommand($event, row)">
                  <span class="el-dropdown-link">
                    <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="snUserChangeCheck && row.changeStat === 1 && !row.processId" command="1">提交审核</el-dropdown-item>
                    <el-dropdown-item v-if="snUserChangeCheckPass && row.changeStat === 2 && !row.processId" command="2">审核通过</el-dropdown-item>
                    <el-dropdown-item v-if="snUserChangeReject && row.changeStat === 2 && !row.processId" command="3">驳回</el-dropdown-item>
                    <el-dropdown-item v-if="snUserChangeCancel && (row.changeStat === 1 || row.changeStat === 6) && !row.processId" command="4">取消</el-dropdown-item>
                    <el-dropdown-item v-if="snUserChangeReview && row.changeStat === 1 && !row.processId" command="5">启动流程</el-dropdown-item>
                    <el-dropdown-item v-if="row.processId" command="6">查看流程</el-dropdown-item>

                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      :visible.sync="showPicDialog"
      title="流程图">
      <img v-if="showPicDialog" :src="actPicUrl" width="100%">
    </el-dialog>

    <accountCheck v-if="showAccountCheckDialog" @followUpAccountCheck="followUpAccountCheck"
                 :visiable.sync="showAccountCheckDialog" :param="orderRemarkParam" />

  </div>
</template>

<script>
import editView from './edit.vue';
import {initVxeTable} from '@/const/crud/admin/table'
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import {mapGetters} from "vuex";
import request from "@/router/axios";
import {indexPageMixins, siteMixins} from "@/mixins/tabChang";

//审核填写登录账号
import accountCheck from "@/views/service/change/changeFacilitator/accountCheck";

export default {
	name: 'changeFacilitator',
  mixins: [siteMixins, indexPageMixins],
  components: {editView, pager,accountCheck},
  data() {
    return {
      actPicUrl:"",
      showPicDialog:false,
      snUserChangeEdit : false,
      snUserChangeAdd : false,
      snUserChangeCheck : false,
      snUserChangeCheckPass : false,
      snUserChangeReject : false,
      snUserChangeCancel : false,
      snUserChangeReview  : false,
      mySnUserChangeEdit : false,
      mySnUserChangeAdd : false,
      total: 0,
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        stat: '',
        userName: '',
        userMobile: ''
      },
      editViewDataUpdateFlag: false,
      showAccountCheckDialog: false,
      orderRemarkParam: {},
      vxeOption: {},
      pageSizes: [10, 20, 100],
      formData: {
        userName: '',
        userMobile: '',
        stat: null,
        userAccount: null
      },
      columns: [
        {type: 'checkbox', width: 48, resizable: false, fixed: 'left'},
        { title: '变更单号', field: 'changeNo', width: 180, slots: {
            // 使用 JSX 渲染
            default: ({row}) => {
              return [
                <span style="color: blue"
                      onClick={($event) => this.openInfoDialog(row, $event)}>{row.changeNo}</span>
              ]
            }
          }
        },
        { field: 'changeType', title: '变更类型', width: 140, slots: {
            default: ({row}) => {
              if (row.changeType == 1) {
                return [
                  <div class="txt-status">
                    <span>新增</span>
                  </div>
                ];
              } else if (row.changeType == 2) {
                return [
                  <div class="txt-status">
                    <span>资料变更</span>
                  </div>
                ];
              }  else if (row.changeType == 3) {
                return [
                  <div class="txt-status ">
                    <span>暂挂</span>
                  </div>
                ];
              } else if (row.changeType == 4) {
                return [
                  <div class="txt-status disable">
                    <span>撤点</span>
                  </div>
                ];
              } else if (row.changeType == 5) {
                return [
                  <div class="txt-status disable">
                    <span>黑名单</span>
                  </div>
                ];
              }
            }
          }
        },
        { field: 'changeStat', title: ' 变更状态', width: 120, slots: {
            default: ({row}) => {
              if (row.changeStat == 1) {
                return [
                  <div class="txt-status">
                    <span>制单</span>
                  </div>
                ];
              } else if (row.changeStat == 2) {
                return [
                  <div class="txt-status">
                    <span>审核中</span>
                  </div>
                ];
              }  else if (row.changeStat == 5) {
                return [
                  <div class="txt-status ">
                    <span>已审核</span>
                  </div>
                ];
              } else if (row.changeStat == 6) {
                return [
                  <div class="txt-status disable">
                    <span>驳回</span>
                  </div>
                ];
              } else if (row.changeStat == 99) {
                return [
                  <div class="txt-status disable">
                    <span>取消</span>
                  </div>
                ];
              }
            }
          }
        },
        { title: '网点名称', field: 'siteName', width: 130, },
        /*{ title: '服务商名称', field: 'userShortName', width: 110 },*/
        { title: '运营状态', field: 'snSiteInfoChangeDTO.businessStat', width: 110,
        slots: {
            default: ({row}) => {
              if (row.snSiteInfoChangeDTO.businessStat == 1) {
                return [
                  <div class="txt-status">
                    <span>提报</span>
                  </div>
                ];
              } else if (row.snSiteInfoChangeDTO.businessStat == 2) {
                return [
                  <div class="txt-status">
                    <span>备用</span>
                  </div>
                ];
              } else if (row.snSiteInfoChangeDTO.businessStat == 3) {
                return [
                  <div class="txt-status">
                    <span>正常</span>
                  </div>
                ];
              } else if (row.snSiteInfoChangeDTO.businessStat == 4) {
                return [
                  <div class="txt-status  disable">
                    <span>清账</span>
                  </div>
                ];
              } else if (row.snSiteInfoChangeDTO.businessStat == 5) {
                return [
                  <div class="txt-status disable">
                    <span>终止</span>
                  </div>
                ];
              } else if (row.snSiteInfoChangeDTO.businessStat == 9) {
                return [
                  <div class="txt-status disable">
                    <span>黑名单</span>
                  </div>
                ];
              }
            }
          } },
        { title: '联系方式', field: 'userMobile', width: 110 },
        { title: '服务中心', field: 'snSiteInfoChangeDTO.orgName', width: 130 },
        { title: '地区', field: 'address', width: 220, slots: {
            default: ({row}) => {
              return [
                <div>
                  <span>{row.userProvince}{row.userCity}{row.userCounty}{row.userTown}</span>
                </div>
              ]
            }
          }},
        { title: '性质', field: 'siteTypeName', width: 120},
        // { title: '服务商编码', field: 'code', width: 150 },

        { title: '创建人', field: 'createBy', width: 80 },
        { field: 'createTime', title: '创建时间', width: 150 },
        { width: 47, fixed: 'right', title: '', sortable: false, slots: {
            default: ({row}) => {
              if (this.snUserChangeEdit || this.mySnUserChangeEdit){
                return [
                  <div>
                    <a href="javascript:void(0);" class="a-link" onclick={() => {
                      this.openEditDialog(row, 'edit');
                    }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-edit"/>
                      </el-tooltip>
                    </a>
                  </div>
                ];
              }
            }
          }
        },
        {
          width: 60, fixed: 'right', title: '操作', sortable: false, slots: {default: 'option'}
        }
      ],







      activeName: 'second',
      dataId: 0,
      showEdit: false,
      showSave: true,

    };
  },
  mounted() {

  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created(){
    this.snUserChangeEdit = this.permissions['snUserChangeEdit']
    this.snUserChangeAdd = this.permissions['snUserChangeAdd']
    this.snUserChangeCheck = this.permissions['snUserChangeCheck']
    this.snUserChangeCheckPass = this.permissions['snUserChangeCheckPass']
    this.snUserChangeReject = this.permissions['snUserChangeReject']
    this.snUserChangeCancel = this.permissions['snUserChangeCancel']
    this.snUserChangeReview = this.permissions['snUserChangeReview']
    this.mySnUserChangeEdit = this.permissions['mySnUserChangeEdit']
    this.mySnUserChangeAdd = this.permissions['mySnUserChangeAdd']
  },
  watch: {
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    },
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
  },
  methods: {
    toFilterData() {
            this.searchEvent();
     },

    // 菜单选中
    handleCommand(command, row) {
      if(command == 5){
        request({
          url: '/act/wf/startWf',
          method: 'post',
          data:{id:row.id,tableKey:"SnUserChange",orgId:row.snSiteInfoChangeDTO.orgId,orderNo:row.changeNo},
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          console.log("response",response)
          if(response.data.type == "success"){
            this.$message({ message:response.data.content,type: 'success'});
            this.flushed();
            this.reload();
          }else{
            this.$message({ message:response.data.content,type: 'warning'});
          }
        })
      }else if (command == 1){
        this.showAccountCheckDialog = true
        this.orderRemarkParam.orderId = row.id
        this.orderRemarkParam.changeNo = row.changeNo
        //this.updateChangeStat(2,row.id.toString())
      }else if (command == 2){
        this.passTheAudit(row.id.toString())
      }else if (command == 3){
        this.updateChangeStat(6,row.id.toString())
      }else if (command == 4){
        this.updateChangeStat(99,row.id.toString())
      }else if (command == 6){
        this.actPicUrl = `/act/wf/wfview/` + row.processId
        this.showPicDialog = true
      }
    },


    followUpAccountCheck(type) {
      this.showAccountCheckDialog = false;
      if (type == 1) {
        this.flushed()// 需要刷新页面
      }
    },

    updateChangeStat(changeStat,id){ //更新变更状态
      console.log("this.dataId",this.dataId)
      console.log("changeStat",changeStat)
      this.$http({
        url: api.snUserChange.updateChangeStatUrl,
        method: 'post',
        data: {
          changeId: id,
          changeStat : changeStat
        }
      }).then(res => {
        if (res.data.data){
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        }
        this.flushed();
        this.reload()
      })
    },

    passTheAudit(id){ // 审核通过
      this.$http({
        url: api.snUserChange.passTheAuditUrl,
        method: 'post',
        data: {
          id: id
        }
      }).then(res => {
        if (res.data.data){
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        }
        this.flushed();
        this.reload()
      })
    },

    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.snUserChange.getPageDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      this.requestParam.userAccount = this.formData.userAccount
      this.requestParam.userName = this.formData.userName
      this.requestParam.stat = this.formData.stat

      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 重置
    resetEvent() {
      this.formData = {
        userName: '',
        userMobile: '',
        stat: ''
      }

      this.requestParam.userName = ''
      this.requestParam.userMobile = ''
      this.requestParam.stat = ''
      this.requestParam.searchCount = false
      this.requestParam.current = 1

      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    editViewDataUpdate() {
      this.getTableData()
    },

    openInfoDialog(row, $event) {
      this.showSave = false
      this.dataId = !row.id || typeof row.id == 'object' ? 0 : row.id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },


    // 新增
    openEditDialog(row, type) {
      this.type = type
      this.dataId = !row.id || typeof row.id == 'object' ? 0 : row.id;
      this.processId=row.processId
      this.showSave = true
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },

  }
};
</script>
<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}
</style>
